import { browserSupportsWebAuthn } from '@simplewebauthn/browser'

/**
 * パスキー（WebAuthn）対応環境かどうかを判定する
 * 非対応環境では訴求ダイアログや登録メニューを表示しない
 */
export const isPasskeySupported = () => {
  return typeof window !== 'undefined' && browserSupportsWebAuthn()
}

/**
 * ユーザーがOSのパスキー操作をキャンセルした等、
 * エラー表示が不要な中断かどうかを判定する
 */
export const isPasskeyCancelError = (e: unknown) => {
  return e instanceof Error && e.name === 'NotAllowedError'
}

const PROMOTION_PENDING_KEY = 'gyym:passkeyPromotionPending'
// ログイン直後の遷移先でプロフィール登録モーダルを抑止するためのマーカー。
// パスキー訴求フラグ（PROMOTION_PENDING_KEY）は Watcher が消費するため、
// マウント順に依存せず確実に抑止できるよう独立したキーで管理する。
const PROFILE_MODAL_SUPPRESS_KEY = 'gyym:suppressProfileModalAfterLogin'

/**
 * ログイン成功時に「次のページでパスキー訴求ダイアログを表示する」フラグを立てる
 * ログインページ（App Router）から遷移先（Pages Router）へのハード遷移を跨ぐため
 * sessionStorage を利用する
 */
export const setPasskeyPromotionPending = () => {
  try {
    window.sessionStorage.setItem(PROMOTION_PENDING_KEY, '1')
    // 同じログインの遷移先ではプロフィール登録モーダルを出さずパスキー訴求のみ表示する
    window.sessionStorage.setItem(PROFILE_MODAL_SUPPRESS_KEY, '1')
  } catch {
    // sessionStorage が使えない環境では訴求しない
  }
}

/**
 * ログイン直後のプロフィール登録モーダル抑止マーカーを「消費」する（読み取り＋削除）。
 * プロフィール登録 effect がマウント毎に1度だけ呼び、当該ランディングでのみ抑止する。
 * パスキー訴求フラグとは別キーのため、Watcher の消費タイミングに影響されない。
 */
export const consumeSuppressProfileModalAfterLogin = () => {
  try {
    const suppress =
      window.sessionStorage.getItem(PROFILE_MODAL_SUPPRESS_KEY) === '1'
    if (suppress) {
      window.sessionStorage.removeItem(PROFILE_MODAL_SUPPRESS_KEY)
    }
    return suppress
  } catch {
    return false
  }
}

export const consumePasskeyPromotionPending = () => {
  try {
    const pending =
      window.sessionStorage.getItem(PROMOTION_PENDING_KEY) === '1'
    if (pending) {
      window.sessionStorage.removeItem(PROMOTION_PENDING_KEY)
    }
    return pending
  } catch {
    return false
  }
}
